import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-how-to-ride',
  templateUrl: './how-to-ride.component.html',
})
export class HowToRideComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }
}
